import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/activeClientsSagas";

import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import CrossRegionalVisits from "./smartComponents/crossRegionalVisits";
import LearnMore from "../../../../components/learnMore/learnMore";
import CustomDateRanges from "./smartComponents/customDateRanges";
import TableChart from "./smartComponents/tableChart";
import PeriodType from "./smartComponents/periodType";
import DatePicker from "./smartComponents/datePicker";
import LineChart from "./smartComponents/lineChart";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import "../attendance_common.css.scss";

const ActiveClientsModule = (props) => {
  const dispatch = useDispatch();
  const sourceType = useSelector((state) => state.commonReducer.commonProps.sourceType);
  const toggles = useSelector((state) => state.activeClients.filters.toggles);
  const initialRequest = useSelector((state) => state.activeClients.initialRequest);
  const updatesLoading = useSelector((state) => state.activeClients.updatesLoading);
  const isLoading = useSelector((state) => state.activeClients.isLoading);
  const isCrossRegionalVisitsIncluded = useSelector(
    (state) => state.activeClients.filters.toggles.crossRegionalVisits.default
  );

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => (
    <div>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="top-filter">
          <div>
            {sourceType === "clubready" && isCrossRegionalVisitsIncluded && (
              <div className="select-box-no-width">
                <p>{toggles.crossRegionalVisits.label}</p>
                <CrossRegionalVisits />
              </div>
            )}
          </div>

          <div className="top-filter__right">
            <div className="select-box-no-width">
              <p>Period Type</p>
              <PeriodType />
            </div>

            <div className="select-box-no-width date-range-select-box">
              <p>Date Range</p>
              <CustomDateRanges />
            </div>

            <div className="date-select-box select-box-no-width multi">
              <p>Date</p>
              <DatePicker />
            </div>

            <UpdateBtns />
          </div>
        </div>
      </div>
      <div className="chart-root">
        {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <LineChart />}
      </div>
      <div className="chart-root">
        {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <TableChart />}
      </div>
    </div>
  );

  return (
    <div id="attendance-root">
      <SectionToggle
        autoHeight
        height={690}
        title={`Active ${props.clientName}`}
        isLoading={isLoading}
        content={content()}
        learnMore={<LearnMore {...learnMoreProps(props.clientName)} />}
      />
    </div>
  );
};

let learnMoreProps = (clientName) => {
  let clientNameLowerCased = clientName?.toLowerCase();
  return {
    title: `Active ${clientName} Chart`,
    customStyles: { width: "500px" },
    content: (
      <p>
        {`The Active ${clientName} chart shows you how many ${clientNameLowerCased} 
        had a visit in the week/month/day displayed. Separated by new ${clientNameLowerCased} 
        and existing ${clientNameLowerCased}.`}
        <br />
        {`When you select the period type of ‘Weekly’,
        your data will be aggregated for entire week.`}
      </p>
    )
  };
};

export default React.memo(ActiveClientsModule);
